// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "container-3KRzk";
var _5 = "withIcons-19wVZ";
var _6 = "field_birthdate-3zf0f";
var _7 = "field_sex-1Pjt0";
var _8 = "documents-23rsn";
var _9 = "accompanying-Y8ESo";
var _a = "field_middleName-2O3C8";
var _b = "contacts-1zo4F";
var _c = "icon-2Dw1V";
var _d = "identity-15VXu";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "container", _5 as "withIcons", _6 as "field_birthdate", _7 as "field_sex", _8 as "documents", _9 as "accompanying", _a as "field_middleName", _b as "contacts", _c as "icon", _d as "identity" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "container": _4, "withIcons": _5, "field_birthdate": _6, "field_sex": _7, "documents": _8, "accompanying": _9, "field_middleName": _a, "contacts": _b, "icon": _c, "identity": _d }
